import { render, staticRenderFns } from "./BookingAddress.vue?vue&type=template&id=038d5fb4&"
import script from "./BookingAddress.vue?vue&type=script&lang=js&"
export * from "./BookingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports